/* ODE – gesammelte Skripte aus den Kopf-Snippets (defer). Jeder Teil läuft für sich. Erzeugt am 11.10.2026, Tempo-Umbau 12.10.2026. */

/* 12.10. Tempo: Jeder Teil läuft als eigene kleine Aufgabe, wenn der Browser Luft hat (vorher alle zusammen als ein langer Block
   direkt beim Laden). Sofort laufen nur Kopfzeile, Altersabfrage und Zustandsklassen. */
(function () {
  var q = [], lauf = false;
  var ric = window.requestIdleCallback || function (f) { return setTimeout(function () { f({ timeRemaining: function () { return 8; }, didTimeout: true }); }, 1); };
  var weiter = function () {
    var x = q.shift();
    if (x) { try { x[1](); } catch (e) { if (window.console) console.error('ODE ' + x[0], e); } }
    if (q.length) ric(weiter, { timeout: 1200 }); else lauf = false;
  };
  window.__odeT = function (n, f, sofort) {
    if (sofort) { try { f(); } catch (e) { if (window.console) console.error('ODE ' + n, e); } return; }
    q.push([n, f]);
    if (!lauf) { lauf = true; ric(weiter, { timeout: 1200 }); }
  };
  window.__odeLoad = function (f) { if (document.readyState === 'complete') setTimeout(f, 0); else addEventListener('load', f); };
  /* Warenkorb-Zähler beobachten: nur im Kopf (dort sitzt die Zahl) plus Horizons cart:update, gebündelt. */
  window.__odeKorbBeob = function (fn) {
    var g = false, bald = function () { if (g) return; g = true; setTimeout(function () { g = false; fn(); }, 120); };
    document.addEventListener('cart:update', bald);
    var start = function () { var z = document.querySelector('#header-group') || document.body; new MutationObserver(bald).observe(z, { childList: true, subtree: true, characterData: true }); };
    if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
  };
})();

/* --- ode-korrekturen:L937:js --- */
__odeT('ode-korrekturen:L937:js', function () {
/* 05.10.: Header "beim Hochscrollen zeigen" flackerte (Über uns, Produktseite). Horizon blendet ihn
     bei jedem Scroll-Ereignis ohne Aufwärtsbewegung aus, auch bei 0 px oder Trackpad-Zittern.
     Hier eine Schwelle: erst nach 12 px in eine Richtung wird gewechselt. Setzt Horizon den
     Zustand vorher um, wird er vor dem Zeichnen zurückgestellt. */
  (function start() {
    var h = document.querySelector('header-component[sticky="scroll-up"]');
    if (!h) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); return; }
    if (window.__odeKopfRuhe) return; window.__odeKopfRuhe = true;
    var SCHWELLE = 12, letzt = null, hoch = 0, runter = 0, soll = null, selbst = false;
    /* 09.10. Tempo: keine Layout-Abfragen mehr pro Scroll-Ereignis (vorher scrollHeight + getComputedStyle +
       getBoundingClientRect bei jedem Ereignis, doppelt registriert -> erzwungenes Layout, Ruckeln).
       Die Position kommt direkt vom Ereignis: Dokument -> scrollY, .page-wrapper (Desktop) -> scrollTop.
       Andere Scroller (Karussells, Listen) werden ignoriert. */
    var setzen = function (st) {
      selbst = true;
      h.dataset.stickyState = st; h.dataset.scrollDirection = st === 'active' ? 'up' : 'none';
      selbst = false;
    };
    var quelle = null, geplant = false;
    var beimScrollen = function (e) {
      var t = e.target;
      if (t === document || t === document.documentElement || t === document.body) quelle = null;
      else if (t && t.classList && t.classList.contains('page-wrapper')) quelle = t;
      else return;
      if (!geplant) { geplant = true; requestAnimationFrame(rechnen); }
    };
    var rechnen = function () {
      geplant = false;
      var y = quelle ? quelle.scrollTop : window.scrollY;
      if (letzt === null) { letzt = y; return; }
      var d = y - letzt; letzt = y;
      if (d < 0) { hoch -= d; runter = 0; } else if (d > 0) { runter += d; hoch = 0; }
      if (hoch >= SCHWELLE) soll = 'active'; else if (runter >= SCHWELLE) soll = 'idle';
      if (y < 4 && h.dataset.stickyState === 'inactive') soll = null;
    };
    document.addEventListener('scroll', beimScrollen, { capture: true, passive: true });
    new MutationObserver(function () {
      if (selbst || !soll) return;
      var st = h.dataset.stickyState;
      if ((st === 'active' || st === 'idle') && st !== soll) setzen(soll);
    }).observe(h, { attributes: true, attributeFilter: ['data-sticky-state'] });
  })();
}, true);

/* --- ode-korrekturen:L981:js --- */
__odeT('ode-korrekturen:L981:js', function () {
(function () {
    var ZIEL = 'https://storefinder.ode-aperitif.com/';
    var los = function () {
      document.querySelectorAll('header a[href], .header a[href], .menu-drawer a[href], .header__drawer a[href], footer a[href], .footer a[href]').forEach(function (a) {
        var h = a.getAttribute('href') || '';
        if (/^(https:\/\/ode-aperitif\.com)?\/pages\/(haendler|storefinder)\/?(\?|#|$)/.test(h)) { a.setAttribute('href', ZIEL); h = ZIEL; }
        if (h.indexOf('storefinder.ode-aperitif.com') > -1 && !a.classList.contains('ode-extern')) {
          a.classList.add('ode-extern');
          var sr = document.createElement('span'); sr.className = 'visually-hidden'; sr.textContent = (document.documentElement.lang || '').indexOf('en') === 0 ? ' (new tab)' : ' (neuer Tab)'; a.appendChild(sr);
        }
      });
      /* 06.10. (Runde 2, Idee 25): "Trinke verantwortungsvoll" führt zu drinkiq.com - Pfeil, neuer Tab, Erklärung. */
      document.querySelectorAll('a[href*="drinkiq.com"], a[href*="massvoll-geniessen.de"]').forEach(function (a) {
        if (a.dataset.odeExtern) return; a.dataset.odeExtern = '1';
        var en = (document.documentElement.lang || '').indexOf('en') === 0;
        var dom = a.hostname.replace(/^www\./, '');
        a.classList.add('ode-extern'); a.setAttribute('target', '_blank'); a.setAttribute('rel', 'noopener');
        a.setAttribute('title', en ? 'Tips on drinking responsibly, on ' + dom + ' (opens in a new tab)' : 'Tipps zum verantwortungsvollen Genuss, auf ' + dom + ' (neuer Tab)');
        var sr = document.createElement('span'); sr.className = 'visually-hidden'; sr.textContent = en ? ' (external: ' + dom + ', new tab)' : ' (externe Seite: ' + dom + ', neuer Tab)'; a.appendChild(sr);
      });
      document.querySelectorAll('a[href*="storefinder.ode-aperitif.com"]').forEach(function (a) {
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener');
      });
    };
    /* Der Header wird nach dem Laden noch einmal neu aufgebaut (Horizon). Deshalb nicht nur */
    /* einmal setzen, sondern bei jeder Aenderung im Dokument kurz nachziehen. */
    var geplant = false;
    var bald = function () { if (geplant) return; geplant = true; setTimeout(function () { geplant = false; los(); }, 200); };
    /* 12.10. Tempo: nur Kopf und Fuß beobachten (vorher die ganze Seite) und gebündelt nachziehen. */
    var start = function () { los(); ['#header-group', 'footer'].forEach(function (q) { var n = document.querySelector(q); if (n) new MutationObserver(bald).observe(n, { childList: true, subtree: true }); }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    window.__odeLoad(los);
  })();
});

/* --- ode-korrekturen:L1018:js --- */
__odeT('ode-korrekturen:L1018:js', function () {
(function () {
      if (window.__odeSchub) return; window.__odeSchub = true;
      document.addEventListener('click', function (e) {
        var k = e.target.closest && e.target.closest('[data-ode-schub-add]');
        if (!k) return;
        e.preventDefault();
        k.disabled = true;
        var los = function (korb) {
          korb.add([{ id: Number(k.dataset.odeSchubAdd), quantity: Number(k.dataset.menge) || 1 }], k)
            .catch(function () { k.disabled = false; k.textContent = (document.documentElement.lang || '').indexOf('en') === 0 ? "That didn't work" : 'Hat nicht geklappt'; });
        };
        if (window.odeKorb) los(window.odeKorb);
        else document.addEventListener('ode-korb:bereit', function () { los(window.odeKorb); }, { once: true });
      });
    })();
});

/* --- ode-korrekturen:L1038:js --- */
__odeT('ode-korrekturen:L1038:js', function () {
/* Sterne im Kaufbereich und Kundenzitat springen zu "Was Leute über … sagen" (05.10.). */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.product-information [class*="jdgm-prev-badge"], .product-information .jdgm-widget, [data-zu-stimmen]');
    if (!t) return;
    var ziel = Array.prototype.find.call(document.querySelectorAll('.ode-sm'), function (el) { return el.offsetHeight > 0; });
    if (!ziel) return;
    e.preventDefault();
    ziel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});

/* --- ode-korrekturen:L1051:js --- */
__odeT('ode-korrekturen:L1051:js', function () {
/* 05.10.: Lauftext (Horizon-Marquee) nur animieren, solange er sichtbar ist. */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var los = function () {
      var io = new IntersectionObserver(function (e) {
        e.forEach(function (x) { x.target.querySelectorAll('.marquee__wrapper').forEach(function (w) { w.classList.toggle('ode-ruht', !x.isIntersecting); }); });
      });
      document.querySelectorAll('marquee-component').forEach(function (m) { io.observe(m); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los); else los();
  })();
});

/* --- ode-anruf:L69:js --- */
__odeT('ode-anruf:L69:js', function () {
/* Erst nach dem ersten Bildschirm zeigen. Position kommt vom Scroll-Ereignis, einmal pro Bild,
       ohne Layout-Abfragen (am Rechner scrollt .page-wrapper, am Handy das Fenster). */
    (function () {
      var a = document.querySelector('.ode-anruf');
      if (!a || window.__odeAnruf) return; window.__odeAnruf = true;
      var vh = innerHeight, da = null, geplant = false, quelle = null, fuss = false;
      var rechnen = function () {
        geplant = false;
        var y = quelle ? quelle.scrollTop : window.scrollY;
        var an = y > vh * 0.8 && !fuss;
        if (an !== da) { da = an; a.classList.toggle('ist-da', an); }
      };
      var pruefen = function (e) {
        var t = e && e.target;
        if (t && t.classList && t.classList.contains('page-wrapper')) quelle = t;
        else if (t && t !== document && t !== document.documentElement && t !== document.body && t.nodeType === 1) return;
        else if (t) quelle = null;
        if (!geplant) { geplant = true; requestAnimationFrame(rechnen); }
      };
      var beobachten = function () {
      var teile = document.querySelectorAll('.shopify-section-group-footer-group, footer');
      if (teile.length && 'IntersectionObserver' in window) {
        var sichtbar = new Set();
        var io = new IntersectionObserver(function (e) {
          e.forEach(function (x) { if (x.isIntersecting) sichtbar.add(x.target); else sichtbar.delete(x.target); });
          fuss = sichtbar.size > 0; rechnen();
        }, { rootMargin: '0px 0px -45% 0px' });
        teile.forEach(function (t) { io.observe(t); });
      }
      };
      /* Das Script steht im Kopf der Seite, der Footer existiert erst nach dem Einlesen. */
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', beobachten); else beobachten();
      document.addEventListener('scroll', pruefen, { passive: true, capture: true });
      addEventListener('resize', function () { vh = innerHeight; pruefen(); });
      rechnen();
    })();
});

/* --- ode-newsletter:L81:js --- */
__odeT('ode-newsletter:L81:js', function () {
(function () {
    if (customElements.get('ode-newsletter')) return;
    var KEY = 'ode-nl';
    var lesen = function () { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return { aus: true }; } };
    var schreiben = function (v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} };

    customElements.define('ode-newsletter', class extends HTMLElement {
      connectedCallback() {
        var st = lesen();
        if (st.aus || st.angemeldet) return;
        if (st.zu && Date.now() - st.zu < 14 * 864e5) return;
        if (/[?&]customer_posted=true/.test(location.search)) { schreiben({ angemeldet: Date.now() }); return; }
        this.hidden = false;
        this.dialog = this.querySelector('dialog');
        var self = this, pdp = this.dataset.produktseite === '1';
        this.querySelectorAll('[data-nl-zu]').forEach(function (b) { b.addEventListener('click', function () { self.zu(); }); });
        this.dialog.addEventListener('cancel', function (e) { e.preventDefault(); self.zu(); });
        this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.zu(); });
        this.querySelector('form').addEventListener('submit', function (e) { self.senden(e); });

        var los = function () { self.zeigen(); };
        this._t = setTimeout(los, pdp ? 45000 : 25000);
        if (!pdp) {
          /* 09.10. Tempo: höchstens einmal pro Bild prüfen, nur Dokument bzw. .page-wrapper, keine Stil-Abfrage. */
          var geplant = false, ziel = null;
          this._scroll = function (e) {
            var t = e.target;
            if (t === document || t === document.documentElement || t === document.body) ziel = document.scrollingElement;
            else if (t && t.classList && t.classList.contains('page-wrapper')) ziel = t;
            else return;
            if (geplant) return; geplant = true;
            requestAnimationFrame(function () {
              geplant = false;
              if (ziel.scrollTop > (ziel.scrollHeight - ziel.clientHeight) * 0.5) los();
            });
          };
          document.addEventListener('scroll', this._scroll, { capture: true, passive: true });
        }
        if (matchMedia('(hover: hover)').matches) {
          this._raus = function (e) { if (!e.relatedTarget && e.clientY <= 4) los(); };
          document.addEventListener('mouseout', this._raus);
        }
      }
      aufraeumen() {
        clearTimeout(this._t);
        if (this._scroll) document.removeEventListener('scroll', this._scroll, { capture: true });
        if (this._raus) document.removeEventListener('mouseout', this._raus);
      }
      zeigen() {
        if (this._gezeigt) return;
        /* Nicht über offene Schubladen oder Dialoge legen. */
        if (document.querySelector('dialog[open]:not(.ode-nl__dialog)')) { var s = this; setTimeout(function () { s._gezeigt = false; s.zeigen(); }, 8000); this._gezeigt = true; return; }
        this._gezeigt = true;
        this.aufraeumen();
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal(); else this.dialog.setAttribute('open', '');
        try { this.dialog.focus({ preventScroll: true }); } catch (e) {}
        var v = this.querySelector('.ode-nl__himmel video');
        if (v && !v.src && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          v.src = innerWidth > 749 && devicePixelRatio > 1 ? v.dataset.srcGross : v.dataset.src;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        }
        document.documentElement.classList.add('ode-nl-offen');
        if (window.gtag) try { gtag('event', 'newsletter_popup_view'); } catch (e) {}
      }
      zu() {
        var st = lesen();
        if (!st.angemeldet) schreiben({ zu: Date.now() });
        this.aufraeumen();
        if (this.dialog.open) this.dialog.close(); else this.dialog.removeAttribute('open');
        document.documentElement.classList.remove('ode-nl-offen');
      }
      senden(e) {
        var form = e.target, feld = form.querySelector('[type="email"]'), fehler = form.querySelector('[data-nl-fehler]'), knopf = form.querySelector('[data-nl-knopf]');
        var en = document.documentElement.lang === 'en';
        if (form.dataset.nativ) return; /* zweiter Versuch: normal abschicken (Bot-Schutz) */
        e.preventDefault();
        fehler.hidden = true; feld.classList.remove('ist-fehler');
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(feld.value.trim())) {
          fehler.textContent = en ? 'Please check your email address.' : 'Bitte prüf deine E-Mail-Adresse.';
          fehler.hidden = false; feld.classList.add('ist-fehler'); feld.focus(); return;
        }
        knopf.disabled = true;
        var self = this;
        fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
          .then(function (r) {
            if (/\/challenge/.test(r.url)) { form.dataset.nativ = '1'; form.submit(); return; }
            return r.text().then(function (html) {
              if (/customer_posted=true/.test(r.url) || /posted_successfully|form--success|customer_posted/.test(html)) {
                schreiben({ angemeldet: Date.now() });
                self.querySelector('[data-nl-schritt="form"]').hidden = true;
                self.querySelector('[data-nl-schritt="danke"]').hidden = false;
                /* 06.10. (Überraschung 25): die Vögel im Himmel fliegen kurz auf */
                if (!matchMedia('(prefers-reduced-motion: reduce)').matches) self.querySelectorAll('video').forEach(function (v) { v.playbackRate = 3; setTimeout(function () { v.playbackRate = 1; }, 1800); });
                if (window.gtag) try { gtag('event', 'generate_lead', { method: 'newsletter_popup' }); } catch (e) {}
              } else {
                fehler.textContent = en ? 'That did not work. Please try again.' : 'Hat nicht geklappt. Bitte nochmal versuchen.';
                fehler.hidden = false; knopf.disabled = false;
              }
            });
          })
          .catch(function () { form.dataset.nativ = '1'; form.submit(); });
      }
    });
  })();
});

/* --- ode-widerruf:L106:js --- */
__odeT('ode-widerruf:L106:js', function () {
(function () {
    if (customElements.get('ode-widerruf')) return;
    var KEY = 'ode-wr-beleg';
    var HASH = '#vertrag-widerrufen';

    customElements.define('ode-widerruf', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.en = document.documentElement.lang === 'en';

        document.addEventListener('click', function (e) {
          var a = e.target.closest && e.target.closest('a[href$="' + HASH + '"], [data-ode-widerruf]');
          if (!a) return;
          var href = a.getAttribute('href') || '';
          /* Nur abfangen, wenn der Link auf dieselbe Seite oder nur auf den Anker zeigt. */
          if (href && href.charAt(0) !== '#') {
            try { var u = new URL(href, location.href); if (u.origin !== location.origin) return; } catch (err) { return; }
          }
          e.preventDefault();
          self.oeffnen();
        });
        window.addEventListener('hashchange', function () { if (location.hash === HASH) self.oeffnen(); });

        this.querySelectorAll('[data-wr-zu]').forEach(function (b) { b.addEventListener('click', function () { self.schliessen(); }); });
        this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.schliessen(); });
        this.dialog.addEventListener('close', function () { document.documentElement.classList.remove('ode-wr-offen'); if (location.hash === HASH) history.replaceState(null, '', location.pathname + location.search); });
        this.querySelector('[data-wr-teil]').addEventListener('change', function () { self.umfang(); });
        this.querySelector('[data-wr-ganz]').addEventListener('change', function () { self.umfang(); });
        this.querySelector('[data-wr-drucken]').addEventListener('click', function () {
          document.documentElement.classList.add('ode-wr-druck');
          window.print();
          setTimeout(function () { document.documentElement.classList.remove('ode-wr-druck'); }, 500);
        });
        this.form.addEventListener('submit', function (e) { self.senden(e); });

        /* Zurück vom Bot-Schutz (normales Absenden): Beleg aus der Sitzung zeigen. */
        if (/[?&]contact_posted=true/.test(location.search)) {
          var beleg = null;
          try { beleg = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (err) {}
          if (beleg && Date.now() - beleg.t < 30 * 60 * 1000) {
            try { sessionStorage.removeItem(KEY); } catch (err) {}
            this.oeffnen(); this.danke(beleg, false);
          }
        } else if (location.hash === HASH) {
          this.oeffnen();
        }
      }
      oeffnen() {
        if (this.dialog.open) return;
        var nl = document.querySelector('.ode-nl__dialog[open]');
        if (nl) nl.close();
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal(); else this.dialog.setAttribute('open', '');
        document.documentElement.classList.add('ode-wr-offen');
      }
      schliessen() {
        if (this.dialog.open) this.dialog.close(); else this.dialog.removeAttribute('open');
      }
      umfang() {
        var teil = this.querySelector('[data-wr-teil]').checked;
        var box = this.querySelector('[data-wr-artikel]');
        box.hidden = !teil;
        box.querySelector('textarea').required = teil;
      }
      zeit() {
        var d = new Date();
        var p = function (n) { return (n < 10 ? '0' : '') + n; };
        return this.en
          ? d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }) + ', ' + p(d.getHours()) + ':' + p(d.getMinutes())
          : p(d.getDate()) + '.' + p(d.getMonth() + 1) + '.' + d.getFullYear() + ', ' + p(d.getHours()) + ':' + p(d.getMinutes()) + ' Uhr';
      }
      daten() {
        var f = this.form, en = this.en, teil = f.querySelector('[data-wr-teil]').checked;
        return {
          t: Date.now(),
          zeit: this.zeit(),
          name: f.querySelector('#ode-wr-name').value.trim(),
          bestellung: f.querySelector('#ode-wr-bestellung').value.trim(),
          umfang: teil ? (en ? 'Some items only' : 'Nur einzelne Artikel') : (en ? 'Entire order' : 'Ganze Bestellung'),
          artikel: teil ? f.querySelector('#ode-wr-artikel').value.trim() : '',
          mail: f.querySelector('#ode-wr-mail').value.trim(),
          en: en
        };
      }
      pruefen() {
        var en = this.en, f = this.form;
        var felder = [
          ['#ode-wr-name', function (v) { return v.length > 1; }, en ? 'Please enter your name.' : 'Bitte gib deinen Namen an.'],
          ['#ode-wr-bestellung', function (v) { return v.length > 2; }, en ? 'Please enter your order number or order date.' : 'Bitte gib Bestellnummer oder Bestelldatum an.'],
          ['#ode-wr-mail', function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }, en ? 'Please check your email address.' : 'Bitte prüf deine E-Mail-Adresse.']
        ];
        if (f.querySelector('[data-wr-teil]').checked) felder.splice(2, 0, ['#ode-wr-artikel', function (v) { return v.length > 1; }, en ? 'Please tell us which items.' : 'Bitte schreib, welche Artikel.']);
        f.querySelectorAll('.ist-fehler').forEach(function (x) { x.classList.remove('ist-fehler'); });
        for (var i = 0; i < felder.length; i++) {
          var el = f.querySelector(felder[i][0]);
          if (!felder[i][1](el.value.trim())) { el.classList.add('ist-fehler'); el.focus(); return felder[i][2]; }
        }
        return '';
      }
      senden(e) {
        var f = this.form, self = this;
        if (f.dataset.nativ) return;
        e.preventDefault();
        var fehler = f.querySelector('[data-wr-fehler]'), knopf = f.querySelector('[data-wr-knopf]');
        fehler.hidden = true;
        var msg = this.pruefen();
        if (msg) { fehler.textContent = msg; fehler.hidden = false; return; }

        var d = this.daten();
        f.querySelector('[data-wr-eingang]').value = d.zeit;
        f.querySelector('[data-wr-body]').value =
          'WIDERRUF über die Online-Widerrufsfunktion\n' +
          'Eingang (Gerätezeit der Kundin/des Kunden): ' + d.zeit + '\n' +
          'Name: ' + d.name + '\nBestellung: ' + d.bestellung + '\nUmfang: ' + d.umfang +
          (d.artikel ? '\nArtikel: ' + d.artikel : '') + '\nE-Mail für Eingangsbestätigung: ' + d.mail +
          '\n\nBitte Eingangsbestätigung an die Kundin/den Kunden schicken, falls nicht automatisch geschehen.';
        try { sessionStorage.setItem(KEY, JSON.stringify(d)); } catch (err) {}
        knopf.disabled = true;

        fetch(f.action, { method: 'POST', body: new FormData(f), headers: { Accept: 'text/html' } })
          .then(function (r) {
            if (/\/challenge/.test(r.url)) { f.dataset.nativ = '1'; f.submit(); return; }
            return r.text().then(function (html) {
              if (/contact_posted=true/.test(r.url) || /posted_successfully|form-status--success|contact_posted/.test(html)) {
                try { sessionStorage.removeItem(KEY); } catch (err) {}
                self.danke(d, true);
              } else {
                fehler.textContent = self.en ? 'That did not work. Please try again or email hi@ode-aperitif.com.' : 'Hat nicht geklappt. Bitte nochmal versuchen oder per Mail an hi@ode-aperitif.com.';
                fehler.hidden = false; knopf.disabled = false;
              }
            });
          })
          .catch(function () { f.dataset.nativ = '1'; f.submit(); });
      }
      danke(d, frisch) {
        var en = d.en, dl = this.querySelector('[data-wr-beleg]');
        var zeilen = [
          [en ? 'Received' : 'Eingegangen', d.zeit],
          [en ? 'Name' : 'Name', d.name],
          [en ? 'Order' : 'Bestellung', d.bestellung],
          [en ? 'Scope' : 'Umfang', d.umfang + (d.artikel ? ': ' + d.artikel : '')],
          [en ? 'Email' : 'E-Mail', d.mail],
          [en ? 'Recipient' : 'Empfänger', 'ODE International GmbH, Böttgerstraße 16, 13357 Berlin, hi@ode-aperitif.com']
        ];
        dl.innerHTML = '';
        zeilen.forEach(function (z) {
          var dt = document.createElement('dt'); dt.textContent = z[0];
          var dd = document.createElement('dd'); dd.textContent = z[1];
          dl.appendChild(dt); dl.appendChild(dd);
        });
        var hook = this.dataset.webhook;
        if (hook && frisch) {
          var self = this;
          fetch(hook, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(d) })
            .then(function (r) { if (r.ok) { self.querySelector('[data-wr-mailziel]').textContent = d.mail; self.querySelector('[data-wr-mailhinweis]').hidden = false; } })
            .catch(function () {});
        }
        this.querySelector('[data-wr-schritt="form"]').hidden = true;
        this.querySelector('[data-wr-schritt="danke"]').hidden = false;
        var t = this.querySelector('[data-wr-danke-titel]'); if (t) t.focus();
      }
    });
  })();
});

/* --- ode-kleinigkeiten:L85:js --- */
__odeT('ode-kleinigkeiten:L85:js', function () {
(function () {
    if (window.__odeKlein) return; window.__odeKlein = true;
    var en = (document.documentElement.lang || '').indexOf('en') === 0;

    /* 1. Kauf-Rückmeldung */
    var letzter = null, zeit = 0;
    var zahl = function () {
      var z = document.querySelector('.cart-bubble__text-count');
      return z ? Number((z.textContent || '').trim()) || 0 : 0;
    };
    var vorher = zahl();
    document.addEventListener('click', function (e) {
      var k = e.target.closest && e.target.closest('button[name="add"], .add-to-cart-button, .sticky-add-to-cart__button');
      if (!k || k.disabled) return;
      letzter = k; zeit = Date.now(); vorher = zahl();
    }, true);
    var zeigen = function () {
      var k = letzter; letzter = null;
      document.querySelectorAll('.cart-bubble').forEach(function (b) { b.classList.remove('ode-huepf'); void b.offsetWidth; b.classList.add('ode-huepf'); });
      if (!k || !k.isConnected) return;
      var text = null;
      for (var i = 0; i < k.childNodes.length; i++) { var n = k.childNodes[i]; if (n.nodeType === 3 && n.textContent.trim()) { text = n; break; } }
      if (!text) return;
      var alt = text.textContent;
      text.textContent = en ? 'In your cart ✓' : 'Im Warenkorb ✓';
      k.classList.add('ode-drin');
      setTimeout(function () { text.textContent = alt; k.classList.remove('ode-drin'); }, 1800);
    };
    var beobachten = function () {
      window.__odeKorbBeob(function () {
        var jetzt = zahl();
        if (letzter && Date.now() - zeit < 8000 && jetzt > vorher) zeigen();
        vorher = jetzt;
      });
    };

    /* 2. Nach oben */
    var hoch = document.querySelector('[data-ode-hoch]');
    /* 09.10. Tempo: Seitenlänge nur beim Laden/Größenwechsel messen, nicht bei jedem Scroll-Ereignis
       (scrollHeight erzwingt Layout). Position kommt vom Ereignis (Desktop scrollt in .page-wrapper). */
    var lang = false, da = null, vh = innerHeight;
    var messen = function () {
      vh = innerHeight;
      var w = document.querySelector('.page-wrapper');
      var hoehe = Math.max(document.documentElement.scrollHeight, w ? w.scrollHeight : 0);
      lang = hoehe > vh * 4;
      if (hoch && hoch.hidden !== !lang) hoch.hidden = !lang;
    };
    var quelle = null, geplant = false;
    var rechnen = function () {
      geplant = false;
      var y = quelle ? quelle.scrollTop : window.scrollY;
      var an = lang && y > vh * 2;
      if (an !== da) { da = an; hoch.classList.toggle('ist-da', an); }
    };
    var pruefen = function (e) {
      if (!hoch) return;
      var t = e && e.target;
      if (t && t.classList && t.classList.contains('page-wrapper')) quelle = t;
      else if (t && t !== document && t !== document.documentElement && t !== document.body && t.nodeType === 1) return;
      else if (t) quelle = null;
      if (!geplant) { geplant = true; requestAnimationFrame(rechnen); }
    };
    if (hoch) {
      hoch.addEventListener('click', function () {
        scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        var ziel = document.querySelector('main, #MainContent'); if (ziel) { ziel.setAttribute('tabindex', '-1'); ziel.focus({ preventScroll: true }); }
      });
      document.addEventListener('scroll', pruefen, { passive: true, capture: true });
      addEventListener('resize', function () { messen(); pruefen(); });
      window.__odeLoad(messen);
      /* 11.10. (t056): erste Messung nach dem ersten Bild statt beim Einlesen (scrollHeight erzwang Layout) */
      requestAnimationFrame(function () { setTimeout(messen, 0); });
    }
    /* 3. Liefertag im Warenkorb (Experience 1): [data-ode-liefer] mit data-schluss/min/max */
    var ost = function (j) { var a = j % 19, b = Math.floor(j / 100), c = j % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451), x = h + l - 7 * m + 114; return new Date(Date.UTC(j, Math.floor(x / 31) - 1, (x % 31) + 1)); };
    var key = function (d) { return d.toISOString().slice(0, 10); };
    var frei = function (d) { var j = d.getUTCFullYear(), o = ost(j), p = function (n) { var z = new Date(o); z.setUTCDate(z.getUTCDate() + n); return key(z); }; return [j + '-01-01', j + '-05-01', j + '-10-03', j + '-12-24', j + '-12-25', j + '-12-26', j + '-12-31', p(-2), p(1), p(39), p(50)].indexOf(key(d)) > -1; };
    var werk = function (d) { var w = d.getUTCDay(); return w >= 1 && w <= 5 && !frei(d); };
    var naechst = function (d) { var x = new Date(d); do { x.setUTCDate(x.getUTCDate() + 1); } while (!werk(x)); return x; };
    var wt = en ? ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] : ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
    var mon = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var kurz = function (d) { return en ? wt[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + mon[d.getUTCMonth()] : wt[d.getUTCDay()] + ' ' + d.getUTCDate() + '.' + (d.getUTCMonth() + 1) + '.'; };
    var lfFmt = null;
    var liefer = function () {
      var els = document.querySelectorAll('[data-ode-liefer]:not([data-fertig])'); if (!els.length) return;
      var t = {}; (lfFmt || (lfFmt = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }))).formatToParts(new Date()).forEach(function (p) { t[p.type] = p.value; });
      var heute = new Date(Date.UTC(+t.year, +t.month - 1, +t.day)), min = (+t.hour % 24) * 60 + +t.minute;
      els.forEach(function (el) {
        el.dataset.fertig = '1';
        var s = +el.dataset.schluss || 11, a = +el.dataset.min || 1, b = +el.dataset.max || a;
        var raus = werk(heute) && min < s * 60 ? heute : naechst(heute), von = raus, bis = raus, i;
        for (i = 0; i < a; i++) von = naechst(von);
        for (i = 0; i < b; i++) bis = naechst(bis);
        var sp = el.querySelector('span') || el;
        sp.textContent = (en ? 'Expected delivery: ' : 'Bei dir voraussichtlich ') + (key(von) === key(bis) ? kurz(von) : kurz(von) + ' – ' + kurz(bis));
      });
    };
    /* 4. Wischhinweis Produktgalerie (Experience 3): Handy, einmal pro Browser, wenn die Galerie mehr als ein Bild hat. */
    var wisch = function () {
      if (innerWidth > 749) return;
      try { if (localStorage.getItem('ode-wisch')) return; } catch (e) { return; }
      var g = document.querySelector('.product-information media-gallery'); if (!g) return;
      var sl = g.querySelector('slideshow-slides'); if (!sl || sl.children.length < 2) return;
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; io.disconnect();
        try { localStorage.setItem('ode-wisch', '1'); } catch (e) {}
        var h = document.createElement('span'); h.className = 'ode-wisch'; h.textContent = en ? 'Swipe for more →' : 'Wischen für mehr →';
        g.style.position = g.style.position || 'relative'; g.appendChild(h);
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) { sl.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-36px)' }, { transform: 'translateX(0)' }], { duration: 900, delay: 500, easing: 'ease-in-out' }); }
        setTimeout(function () { h.classList.add('weg'); setTimeout(function () { h.remove(); }, 400); }, 4200);
      }, { threshold: 0.6 });
      io.observe(g);
    };
    var lfT = 0; var start = function () { beobachten(); pruefen(); liefer(); wisch(); new MutationObserver(function () { clearTimeout(lfT); lfT = setTimeout(liefer, 150); }).observe(document.body, { childList: true, subtree: true }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    window.__odeLoad(pruefen);
  })();
});

/* --- ode-stoerer:L156:js --- */
__odeT('ode-stoerer:L156:js', function () {
(function () {
    var el = document.querySelector('[data-ode-stoerer]');
    if (!el || el.dataset.bereit) return; el.dataset.bereit = '1';
    var knopf = el.querySelector('.ode-st0__kugel');
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) el.querySelectorAll('svg').forEach(function (g) { if (g.pauseAnimations) g.pauseAnimations(); });
    var t = {}; ['f1', 'f2', 'm1', 'm2'].forEach(function (k) { var x = el.querySelector('[data-st0-' + k + ']'); if (x) t[k] = { el: x, basis: x.textContent }; });
    var setz = function (k, v) { if (t[k]) t[k].el.textContent = v == null ? t[k].basis : v; };
    var en = el.hasAttribute('data-en'), frei = Number(el.dataset.frei) || 0, mini = Number(el.dataset.mini) || 0;
    var gf = {}; var geld = function (c) { var k = c % 100 ? 2 : 0; return (gf[k] || (gf[k] = new Intl.NumberFormat(en ? 'en-GB' : 'de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: k }))).format(c / 100); };
    var w = { k0: el.querySelector('[data-st0-k0]'), k1: el.querySelector('[data-st0-k1]'), k2: el.querySelector('[data-st0-k2]') };
    var stand = 0, auswahl = 0;
    var wolke = function () {
      /* 11.10. (Thorsten): nur der echte Warenkorb zählt, auf den Cent genau. */
      var s = stand, t;
      if (frei && s >= frei) t = ['', en ? '€0' : '0 €', en ? 'shipping' : 'Versand'];
      else if (s > 0) t = [en ? 'just' : 'noch', geld(frei - s), en ? 'to free shipping' : 'bis 0 € Versand'];
      else t = [en ? 'from' : 'ab', geld(frei), en ? 'free shipping' : '0 € Versand'];
      if (w.k0) w.k0.textContent = t[0]; if (w.k1) w.k1.textContent = t[1]; if (w.k2) w.k2.textContent = t[2];
      el.classList.toggle('ist-frei', !!(frei && s >= frei));
      knopf.setAttribute('aria-label', (t[0] ? t[0] + ' ' : '') + t[1] + ' ' + t[2]);
    };
    document.addEventListener('ode:auswahl', function (e) { auswahl = Number(e.detail && e.detail.summe) || 0; wolke(); });
    /* 11.10.: Dieses Skript startet erst nach dem Einlesen (defer) – die erste Auswahl der Staffel ist dann schon vorbei. Darum den gemerkten Stand übernehmen. */
    if (window.__odeAuswahl) { auswahl = Number(window.__odeAuswahl.summe) || 0; wolke(); }
    var korb = function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var s = Number(c.total_price) || 0;
        stand = s; wolke();
        if (!s) { ['f1', 'f2', 'm1', 'm2'].forEach(function (k) { setz(k); }); return; }
        if (s >= frei) { setz('f1', en ? 'Done!' : 'Geschafft!'); setz('f2', en ? 'free shipping' : 'versandkostenfrei'); }
        else { setz('f1', (en ? 'just ' : 'noch ') + geld(frei - s)); setz('f2', en ? 'to free shipping' : 'bis versandkostenfrei'); }
        if (mini && s >= mini) { setz('m1', en ? 'Free mini!' : 'Mini gratis!'); setz('m2', en ? 'is in' : 'ist dabei'); }
        else if (mini && s >= frei) { setz('m1', (en ? 'just ' : 'noch ') + geld(mini - s)); setz('m2', en ? 'to your free mini' : 'bis zum Gratis-Mini'); }
        else { setz('m1'); setz('m2'); }
      }).catch(function () {});
    };
    /* 08.10. Barrierefreiheit: Die Blasen-Links sind nur im offenen Zustand per Tab erreichbar. */
    var auf = function (an) { el.classList.toggle('ist-offen', an); document.documentElement.classList.toggle('ode-z-st0', an); knopf.setAttribute('aria-expanded', an ? 'true' : 'false'); el.querySelectorAll('.ode-st0__kleber').forEach(function (k) { k.setAttribute('tabindex', an ? '0' : '-1'); }); };
    var fein = matchMedia('(hover: hover) and (pointer: fine)').matches;
    var zu = null;
    if (fein) {
      el.addEventListener('mouseenter', function () { clearTimeout(zu); korb(); auf(true); });
      el.addEventListener('mouseleave', function () { clearTimeout(zu); zu = setTimeout(function () { auf(false); }, 250); });
    }
    knopf.addEventListener('click', function () { var an = !el.classList.contains('ist-offen'); if (an) korb(); auf(an); });
    knopf.addEventListener('focus', function () { if (!fein) return; korb(); auf(true); });
    el.addEventListener('focusout', function (e) { if (fein && !el.contains(e.relatedTarget)) auf(false); });
    document.addEventListener('click', function (e) { if (!el.contains(e.target)) auf(false); });
    addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('ist-offen')) { auf(false); if (el.contains(document.activeElement)) knopf.focus(); } });
    korb();
    var icon = document.querySelector('cart-icon, .header-actions__cart-icon');
    if (icon && window.MutationObserver) { var mt = null; new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(korb, 300); }).observe(icon, { childList: true, subtree: true, characterData: true }); }
    /* Teaser: einmal pro Sitzung kurz aufklappen – erst wenn er wirklich sichtbar aufgeht, gilt er als gezeigt.
       Steht gerade etwas davor (Overlay), wird es alle 5 s erneut versucht, höchstens sechsmal. */
    var gezeigt = function () { try { return !!sessionStorage.getItem('ode-st0'); } catch (e) { return true; } };
    var teaser = function (n) {
      if (gezeigt() || el.classList.contains('ist-offen') || !el.getClientRects().length || !el.classList.contains('ist-da')) { teaserGeplant = false; return; }
      if (getComputedStyle(el).opacity === '0' || document.hidden) { if (n < 6) setTimeout(function () { teaser(n + 1); }, 5000); return; }
      try { sessionStorage.setItem('ode-st0', '1'); } catch (e) {}
      korb(); auf(true);
      setTimeout(function () { if (!el.matches(':hover') && document.activeElement !== knopf) auf(false); }, 3500);
    };
    var teaserGeplant = false;
    /* Sichtbar erst nach dem ersten Bildschirm (Position vom Scroll-Ereignis, einmal pro Bild, ohne Layout-Abfragen;
       am Rechner scrollt .page-wrapper). Der Teaser startet erst, wenn die Kugel das erste Mal sichtbar ist. */
    var vh = innerHeight, da = null, geplant = false, quelle = null;
    var rechnen = function () {
      geplant = false;
      var y = quelle ? quelle.scrollTop : window.scrollY;
      /* 10.10. (Thorsten): im Shop (Kollektionen) sofort da, sonst erst nach dem ersten Bildschirm. */
      var an = el.hasAttribute('data-sofort') || y > vh * 0.8;
      if (an === da) return;
      da = an; el.classList.toggle('ist-da', an);
      if (!an && el.classList.contains('ist-offen')) auf(false);
      if (an && !teaserGeplant && !gezeigt() && !matchMedia('(prefers-reduced-motion: reduce)').matches) { teaserGeplant = true; setTimeout(function () { teaser(0); }, 1500); }
    };
    var pruefen = function (e) {
      var z = e && e.target;
      if (z && z.classList && z.classList.contains('page-wrapper')) quelle = z;
      else if (z && z !== document && z !== document.documentElement && z !== document.body && z.nodeType === 1) return;
      else if (z) quelle = null;
      if (!geplant) { geplant = true; requestAnimationFrame(rechnen); }
    };
    document.addEventListener('scroll', pruefen, { passive: true, capture: true });
    addEventListener('resize', function () { vh = innerHeight; pruefen(); });
    /* 11.10. (t056): erster Stand im nächsten Frame (scrollY beim Einlesen erzwang Layout) */
    pruefen();
  })();
});

/* --- ode-ueberraschungen:L100:js --- */
__odeT('ode-ueberraschungen:L100:js', function () {
(function () {
    if (window.__odeUe) return; window.__odeUe = true;
    var U = window.odeUe || {}, en = !!U.en;
    var ruhig = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var lesen = function (k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } };
    var schreiben = function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} };
    var sLesen = function (k) { try { return sessionStorage.getItem(k); } catch (e) { return '1'; } };
    var sSchreiben = function (k) { try { sessionStorage.setItem(k, '1'); } catch (e) {} };

    /* 8: Kugelregen */
    var regnen = function () {
      if (ruhig) return;
      var r = document.createElement('div'); r.className = 'ode-regen'; r.setAttribute('aria-hidden', 'true');
      var farben = ['#FFE054', '#F22F00', '#FFE054', '#F22F00', '#47A05F'];
      for (var i = 0; i < 30; i++) {
        var k = document.createElement('i'), g = 16 + Math.round(Math.random() * 26);
        k.style.cssText = 'left:' + (Math.random() * 100) + 'vw;width:' + g + 'px;height:' + g + 'px;background:' + farben[i % farben.length] +
          ';--d:' + (1.5 + Math.random() * 1.2).toFixed(2) + 's;--v:' + (Math.random() * 0.6).toFixed(2) + 's;--r:' + Math.round(120 + Math.random() * 300) + 'deg';
        r.appendChild(k);
      }
      document.body.appendChild(r);
      setTimeout(function () { r.remove(); }, 3800);
    };
    var summe = Number(U.summe) || 0, frei = Number(U.frei) || 0;
    var korbPruefen = function () {
      if (!frei) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var neu = Number(c.total_price) || 0;
        if (summe < frei && neu >= frei && !sLesen('ode-regen')) { sSchreiben('ode-regen'); regnen(); }
        summe = neu;
      }).catch(function () {});
    };

    /* 18: Tab-Titel */
    var basis = document.title.replace(/^\(\d+\)\s*/, '');
    var titel = function (n) { document.title = (n > 0 ? '(' + n + ') ' : '') + basis; };
    var zahl = function () { var z = document.querySelector('.cart-bubble__text-count'); return z ? Number((z.textContent || '').trim()) || 0 : 0; };
    var alt = zahl(); titel(alt);
    window.__odeKorbBeob(function () {
      var n = zahl();
      if (n !== alt) { alt = n; titel(n); korbPruefen(); }
    });

    /* 19: Wiederkehrer */
    if (U.seite === 'product' && U.produkt) {
      schreiben('ode-zuletzt', { t: U.produkt.t, u: U.produkt.u, z: Date.now() });
    } else if (U.seite === 'index') {
      var z = lesen('ode-zuletzt');
      if (z && z.u && Date.now() - z.z > 30 * 60 * 1000 && !sLesen('ode-gruss')) (function gruss() {
        if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', gruss, { once: true }); return; }
        sSchreiben('ode-gruss');
        /* 12.10. (Thorsten): auf der Startseite unter der grünen Logo-Leiste statt unter der Navigation (verdeckte das Startbild). */
        var nachMarquee = document.querySelector('main > .shopify-section[id*="__marquee"]');
        var leiste = nachMarquee || document.getElementById('header-group');
        var g = document.createElement('div'); g.className = leiste ? 'ode-gruss ode-gruss--leiste' : 'ode-gruss'; g.setAttribute('role', 'status');
        var t = document.createElement('span');
        t.appendChild(document.createTextNode(en ? 'Good to see you again. Last time: ' : 'Schön, dass du wieder da bist. Zuletzt angesehen: '));
        var a = document.createElement('a'); a.href = z.u; a.textContent = z.t + ' →'; t.appendChild(a);
        var x = document.createElement('button'); x.type = 'button'; x.setAttribute('aria-label', en ? 'Close' : 'Schließen'); x.textContent = '×';
        x.addEventListener('click', function () { g.classList.remove('ist-da'); setTimeout(function () { g.remove(); }, leiste ? 0 : 300); });
        g.appendChild(t); g.appendChild(x);
        if (leiste) {
          /* unter der grünen Leiste (Startseite) bzw. der Navigation, sofort sichtbar, bleibt bis zum Schließen */
          if (nachMarquee) nachMarquee.after(g); else leiste.appendChild(g);
        } else {
          setTimeout(function () {
            document.body.appendChild(g);
            requestAnimationFrame(function () { g.classList.add('ist-da'); });
            setTimeout(function () { if (g.isConnected) x.click(); }, 12000);
          }, 2500);
        }
      })();
    }

    /* 25: Footer-Newsletter -> Vögel fliegen auf */
    var voegel = function (scope) {
      (scope || document).querySelectorAll('.ode-himmel video, video.ode-himmel').forEach(function (v) {
        if (ruhig) return;
        var los = function () { v.playbackRate = 3; setTimeout(function () { v.playbackRate = 1; }, 1800); };
        if (v.readyState > 2) los(); else v.addEventListener('playing', los, { once: true });
      });
    };
    window.odeVoegel = voegel;
    if (/[?&]customer_posted=true/.test(location.search)) setTimeout(function () { voegel(); }, 400);

    /* Experience 2.7: Sortenwechsel. 11.10. (t045): nicht mehr schwebend über der Kaufleiste, sondern
       fest über der Galerie (nur Handy, CSS). Beobachtet nur den Produktbereich und rechnet höchstens
       einmal pro Frame, falls die Galerie beim Variantenwechsel neu gesetzt wird. */
    var swV = document.getElementById('ode-sw-vorlage');
    var swGeplant = false;
    var swSetzen = function () {
      swGeplant = false;
      if (!swV) return;
      document.querySelectorAll('.product-information__media').forEach(function (ort) {
        if (ort.querySelector(':scope > .ode-sw-kopf')) return;
        var k = document.createElement('div');
        k.className = 'ode-sw-kopf';
        k.appendChild(swV.content.cloneNode(true));
        ort.insertBefore(k, ort.firstChild);
      });
    };
    if (swV) {
      swSetzen();
      var swBereich = document.querySelector('.product-information') || document.querySelector('main') || document.body;
      new MutationObserver(function () { if (!swGeplant) { swGeplant = true; requestAnimationFrame(swSetzen); } }).observe(swBereich, { childList: true, subtree: true });
    }

    /* Experience 2.5: Bilder als geladen markieren, dann verschwindet der Farbgrund */
    var geladen = function () {
      document.querySelectorAll('[data-ode-lade] img:not(.ode-da), .product-information media-gallery img:not(.ode-da)').forEach(function (img) {
        if (img.complete && img.naturalWidth) img.classList.add('ode-da');
        else if (!img.dataset.odeLadeH) { img.dataset.odeLadeH = '1'; img.addEventListener('load', function () { img.classList.add('ode-da'); }, { once: true }); }
      });
    };
    geladen(); window.__odeLoad(geladen); setTimeout(geladen, 1500);

    /* 14: Zutaten-Zeichnungen */
    var S = function (d) { return '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; };
    var BILD = {
      zitrone: S('<path d="M8 25c0-8 7-14 16-14s16 6 16 14-7 13-16 13S8 33 8 25z"/><path d="M6 25h2M40 25h2"/><path d="M15 25c2-5 6-8 9-8M24 33c4 0 8-2 10-6"/>'),
      orange: S('<circle cx="24" cy="27" r="13"/><path d="M24 14c0-3 1-5 3-6"/><path d="M27 10c3-3 7-3 10-2-2 3-6 4-10 2z"/><circle cx="20" cy="23" r="0.8"/><circle cx="28" cy="31" r="0.8"/><circle cx="18" cy="31" r="0.8"/>'),
      thymian: S('<path d="M24 42V8"/><path d="M24 14c-4-1-6-3-6-5 3 0 5 2 6 5zM24 14c4-1 6-3 6-5-3 0-5 2-6 5zM24 22c-5-1-7-3-7-6 3 0 6 3 7 6zM24 22c5-1 7-3 7-6-3 0-6 3-7 6zM24 30c-5-1-8-4-8-7 4 0 7 3 8 7zM24 30c5-1 8-4 8-7-4 0-7 3-8 7z"/>'),
      rosmarin: S('<path d="M14 42C20 30 27 18 36 6"/><path d="M18 34l-6-2M20 30l6 2M23 25l-6-3M25 22l6 1M28 17l-5-3M30 14l6 0M33 10l-4-3"/>'),
      pfirsich: S('<path d="M24 14c-8 0-14 6-14 13s6 13 14 13 14-6 14-13-6-13-14-13z"/><path d="M24 14c-3 6-3 18 0 26"/><path d="M24 14c1-3 3-5 6-6M27 11c3-2 7-1 9 1-3 2-6 2-9-1z"/>'),
      hibiskus: S('<circle cx="24" cy="24" r="3"/><path d="M24 21c-2-6-1-12 3-13 4 1 3 9-3 13zM27 24c6-2 12-1 13 3-1 4-9 3-13-3zM24 27c2 6 1 12-3 13-4-1-3-9 3-13zM21 24c-6 2-12 1-13-3 1-4 9-3 13 3z"/><path d="M26 22l6-8"/>'),
      enzian: S('<path d="M17 12c0 10 2 18 7 22 5-4 7-12 7-22-2 2-4 3-7 3s-5-1-7-3z"/><path d="M17 12l3 3 4-4 4 4 3-3"/><path d="M24 34v8M24 38c-3 0-5-1-6-3M24 38c3 0 5-1 6-3"/>'),
      holz: S('<ellipse cx="18" cy="24" rx="8" ry="12"/><ellipse cx="18" cy="24" rx="4" ry="6.5"/><path d="M18 12h18c4 0 6 5 6 12s-2 12-6 12H18"/><path d="M28 18h8M30 30h6"/>'),
      minze: S('<path d="M24 42V14"/><path d="M24 30c-9 0-13-6-12-12 7 0 12 5 12 12zM24 22c9 0 13-6 12-12-7 0-12 5-12 12z"/><path d="M17 22l7 8M31 14l-7 8"/>')
    };
    var NAMEN = {
      zitrone: en ? 'Lemon' : 'Zitrone', orange: en ? 'Orange' : 'Orange', thymian: en ? 'Thyme' : 'Thymian', rosmarin: en ? 'Rosemary' : 'Rosmarin',
      pfirsich: en ? 'Stone fruit' : 'Steinfrucht', hibiskus: en ? 'Hibiscus' : 'Hibiskus', enzian: en ? 'Gentian' : 'Enzian', holz: en ? 'Wood & bark' : 'Holz & Rinde', minze: en ? 'Mint' : 'Minze'
    };
    var MUSTER = [
      [/\b(Amalfi-Zitronen?|Cedro-Zitronen?|Zitronen?|Bergamotte|Limetten?)\b/i, 'zitrone'],
      [/\b(Bitterorangen?|Orangenschalen?|Orangen?|Grapefruits?)\b/i, 'orange'],
      [/\b(Thymian|Thyme)\b/i, 'thymian'], [/\b(Rosmarin|Rosemary)\b/i, 'rosmarin'],
      [/\b(Pfirsich|Aprikosen?|Steinfrucht|Steinfrüchte)\b/i, 'pfirsich'], [/\b(Hibiskus|Hibiscus)\b/i, 'hibiskus'],
      [/\b(Enzian|Gentian)\b/i, 'enzian'], [/\b(Rotsandelholz|Chinarinde|Holz)\b/i, 'holz'], [/\b(Minze|Mint)\b/i, 'minze']
    ];
    var markieren = function (box) {
      if (box.dataset.odeZt) return; box.dataset.odeZt = '1';
      var gesehen = {};
      var w = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, { acceptNode: function (n) {
        return n.parentElement && !n.parentElement.closest('a, button, script, style, .ode-zb, h1, h2, h3') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      } });
      var knoten = []; while (w.nextNode()) knoten.push(w.currentNode);
      knoten.forEach(function (n) {
        for (var i = 0; i < MUSTER.length; i++) {
          var art = MUSTER[i][1]; if (gesehen[art]) continue;
          var m = n.textContent.match(MUSTER[i][0]); if (!m) continue;
          gesehen[art] = true;
          var vor = n.splitText(m.index); var rest = vor.splitText(m[0].length);
          var s = document.createElement('span'); s.className = 'ode-zb'; s.tabIndex = 0; s.textContent = m[0];
          var b = document.createElement('span'); b.className = 'ode-zb__bild'; b.setAttribute('aria-hidden', 'true'); b.innerHTML = BILD[art] + '<span>' + NAMEN[art] + '</span>';
          s.appendChild(b); vor.parentNode.replaceChild(s, vor);
          n = rest;
        }
      });
    };
    document.addEventListener('click', function (e) {
      var z = e.target.closest && e.target.closest('.ode-zb');
      document.querySelectorAll('.ode-zb.ist-offen').forEach(function (x) { if (x !== z) x.classList.remove('ist-offen'); });
      if (z) z.classList.toggle('ist-offen');
    });
    var start = function () {
      if (!window.odeZutatBilder) return; /* 06.10.: ausgeschaltet */
      document.querySelectorAll('.ode-ar__text ul, .ode-reg__fach, .ode-kopf__noten, [data-ode-zutaten]').forEach(markieren);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();
});

/* --- ode-altersabfrage:L82:js --- */
__odeT('ode-altersabfrage:L82:js', function () {
(function () {
    var d = document.querySelector('[data-ode-aa]'); if (!d) return;
    var html = document.documentElement;
    var lang = ((navigator.languages && navigator.languages[0]) || navigator.language || 'de-DE').toLowerCase();
    var seiteEn = (html.lang || '').indexOf('en') === 0;
    var ausland = seiteEn || !(lang === 'de' || lang === 'de-de');
    var deutsch = !seiteEn && lang.indexOf('de') === 0;
    d.querySelectorAll('[data-aa-sprache]').forEach(function (x) { x.hidden = (x.dataset.aaSprache === 'de') !== deutsch; });
    var gesehen = false; try { gesehen = localStorage.getItem('ode-ausland') === '1'; } catch (e) {}
    var schritt = function (n) { d.querySelectorAll('[data-aa-schritt]').forEach(function (x) { x.hidden = x.dataset.aaSchritt !== n; }); d.querySelector('[data-aa-fuss]').hidden = n === 'ausland'; };
    var oeffnen = function (n) {
      schritt(n);
      if (!d.open) { if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', ''); }
      html.classList.add('ode-aa-offen'); d.classList.remove('ist-weg');
      if (n === 'ausland') { var w = [].find.call(d.querySelectorAll('[data-aa-weiter]'), function (x) { return x.offsetParent !== null; }); if (w) w.focus({ preventScroll: true }); }
    };
    var schliessen = function () {
      html.classList.remove('ode-aa-offen'); d.classList.add('ist-weg');
      setTimeout(function () { d.close(); }, 250);
    };
    d.addEventListener('cancel', function (e) { if (!html.classList.contains('ode-alter-ok')) e.preventDefault(); });
    d.querySelector('[data-aa-ja]').addEventListener('click', function () {
      try { localStorage.setItem('ode-alter', JSON.stringify({ ok: true, z: Date.now() })); } catch (e) {}
      html.classList.add('ode-alter-ok');
      if (ausland && !gesehen) { try { localStorage.setItem('ode-ausland', '1'); } catch (e) {} gesehen = true; oeffnen('ausland'); }
      else schliessen();
    });
    d.querySelector('[data-aa-nein]').addEventListener('click', function () { schritt('nein'); });
    d.querySelectorAll('[data-aa-weiter]').forEach(function (k) { k.addEventListener('click', schliessen); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href$="#ausland"]'); if (!a) return;
      e.preventDefault();
      oeffnen(html.classList.contains('ode-alter-ok') ? 'ausland' : 'frage');
    });
    var start = function () {
      if (!html.classList.contains('ode-alter-ok')) oeffnen('frage');
      else if (ausland && !gesehen) { try { localStorage.setItem('ode-ausland', '1'); } catch (e) {} oeffnen('ausland'); }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();
}, true);

/* --- ode-korrekturen:L100:js --- */
__odeT('ode-korrekturen:L100:js', function () {
/* 09.10. Tempo: Bilder asynchron dekodieren lassen (Safari/iOS dekodiert sonst große Fotos beim Reinscrollen
     auf dem Hauptthread, das ruckelt). Wirkt für alle Bilder, die beim Laden der Seite noch nicht geladen sind. */
  (function () {
    var setzen = function (wurzel) { (wurzel || document).querySelectorAll('img:not([decoding])').forEach(function (i) { i.decoding = 'async'; }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setzen(); }); else setzen();
  })();
}, true);

/* --- ode-korrekturen:L108:js --- */
__odeT('ode-korrekturen:L108:js', function () {
/* 09.10. Tempo: Zustände als Klassen am <html> statt html:has(...)-Regeln. :has() am Wurzelelement lässt den
     Browser bei Änderungen im DOM die Stile der ganzen Seite neu prüfen. Klassen:
     ode-z-menue (Menü offen), ode-z-overlay (Warenkorb/Dialog/Menü offen), ode-z-leiste (Kaufleiste klebt). */
  (function () {
    if (window.__odeZustand) return; window.__odeZustand = true;
    var r = document.documentElement, geplant = false;
    var setze = function (k, an) { if (r.classList.contains(k) !== an) r.classList.toggle(k, an); };
    var pruefen = function () {
      geplant = false;
      var menue = !!document.querySelector('details.menu-drawer-container[open]');
      var overlay = menue || !!document.querySelector('cart-drawer-component[open], .cart-drawer[open], dialog[open]');
      setze('ode-z-menue', menue);
      setze('ode-z-overlay', overlay);
      setze('ode-z-leiste', !!document.querySelector('.sticky-add-to-cart__bar[data-stuck="true"]'));
    };
    var bald = function () { if (!geplant) { geplant = true; requestAnimationFrame(pruefen); } };
    var los = function () {
      new MutationObserver(bald).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open', 'data-stuck'] });
      pruefen();
    };
    if (document.body) los(); else document.addEventListener('DOMContentLoaded', los);
  })();
}, true);

/* --- ode-korrekturen:L132:js --- */
__odeT('ode-korrekturen:L132:js', function () {
(function () {
    if (window.__odeTast) return; window.__odeTast = true;
    var r = document.documentElement;
    addEventListener('keydown', function (e) { if (e.key === 'Tab' && !r.classList.contains('ode-tastatur')) r.classList.add('ode-tastatur'); }, true);
    addEventListener('pointerdown', function () { if (r.classList.contains('ode-tastatur')) r.classList.remove('ode-tastatur'); }, true);
  })();
});

/* --- ode-korrekturen:L140:js --- */
__odeT('ode-korrekturen:L140:js', function () {
/* 09.10. (Thorsten: „scrollt gefühlt immer noch langsam“). Gemessen: Shopify lädt nach dem Seitenaufbau
     den Checkout vor und hängt dafür ~90 <link rel=prefetch> einzeln in den <head>. Wegen der :has()-Regeln
     (Theme + Shopify) rechnet Chrome danach jedes Mal die Stile der ganzen Seite neu (~1800 Elemente).
     Beim Scrollen gab das über 100 Ruckler. Ohne die Vorlade-Links: Stilberechnung 5 s -> 0,3 s.
     Lösung: Diese Links warten, bis 1,2 s nicht gescrollt wurde. Vorgeladen wird weiterhin.
     Test-Schalter: ?ode_still=1 schaltet alle Animationen ab (zum Vergleichen am Handy). */
  (function () {
    var h = document.head; if (!h || h.__odeVorlade) return; h.__odeVorlade = true;
    var orig = h.appendChild, warte = [], zuletzt = 0, t = 0;
    /* 12.10. Tempo: Die Links werden jetzt gesammelt und auf einen Schlag eingehängt (ein Fragment = eine
       Stilberechnung statt ~90), frühestens 400 ms nach dem letzten und nie während gescrollt wird. */
    var raus = function () {
      t = 0;
      if (Date.now() - zuletzt < 1200) { t = setTimeout(raus, 400); return; }
      var f = document.createDocumentFragment(), n; while ((n = warte.shift())) f.appendChild(n);
      orig.call(h, f);
    };
    h.appendChild = function (n) {
      if (n && n.tagName === 'LINK' && /(^|\s)(prefetch|preconnect|dns-prefetch)(\s|$)/.test(n.rel || '')) {
        warte.push(n); clearTimeout(t); t = setTimeout(raus, 400); return n;
      }
      return orig.call(h, n);
    };
    var merken = function () { zuletzt = Date.now(); };
    addEventListener('scroll', merken, { passive: true, capture: true });
    addEventListener('touchmove', merken, { passive: true });
    addEventListener('wheel', merken, { passive: true });
    if (/[?&]ode_still=1/.test(location.search)) {
      var st = document.createElement('style');
      st.textContent = '*,*::before,*::after{animation:none!important;transition:none!important}';
      orig.call(h, st);
    }
  })();
}, true);

/* --- ode-korrekturen:L174:js --- */
__odeT('ode-korrekturen:L174:js', function () {
(function () {
    if (window.__odeBl0) return; window.__odeBl0 = true;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (e) { e.forEach(function (x) { if (x.target.classList.contains('ode-bl0-h--weg') === x.isIntersecting) x.target.classList.toggle('ode-bl0-h--weg', !x.isIntersecting); }); });
    var los = function () { document.querySelectorAll('.ode-bl0-h:not([data-bl0-io])').forEach(function (b) { b.setAttribute('data-bl0-io', ''); io.observe(b); }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los); else los();
    window.__odeLoad(los);
  })();
});

/* --- ode-korrekturen:L249:js --- */
__odeT('ode-korrekturen:L249:js', function () {
(function () {
    if (window.odeA11y1010) return; window.odeA11y1010 = true;
    var laufband = function () {
      document.querySelectorAll('marquee-component').forEach(function (m) {
        var gesehen = {};
        m.querySelectorAll('.marquee__content, .marquee__repeated-items').forEach(function (c, i) {
          var ids = c.querySelectorAll('[id]');
          var kopie = Array.prototype.some.call(ids, function (e) { return gesehen[e.id]; });
          ids.forEach(function (e) { if (gesehen[e.id]) e.removeAttribute('id'); else gesehen[e.id] = true; });
          if (kopie) {
            c.setAttribute('aria-hidden', 'true');
            c.querySelectorAll('a, button, input, [tabindex]').forEach(function (f) { f.setAttribute('tabindex', '-1'); });
          }
        });
      });
    };
    var rest = function () {
      document.querySelectorAll('a.ode-kl__foto').forEach(function (a) {
        if ((a.getAttribute('aria-label') || a.textContent || '').trim()) return;
        a.setAttribute('aria-hidden', 'true'); a.setAttribute('tabindex', '-1');
      });
      var aa = document.querySelector('dialog.ode-aa');
      if (aa && !aa.id && !document.getElementById('ausland')) aa.id = 'ausland';
      var wr = document.querySelector('.ode-wr__dialog');
      if (wr && !wr.id && !document.getElementById('vertrag-widerrufen')) wr.id = 'vertrag-widerrufen';
    };
    var los = function () {
      laufband(); rest();
      var lbG = false; document.querySelectorAll('marquee-component').forEach(function (m) { new MutationObserver(function () { if (lbG) return; lbG = true; requestAnimationFrame(function () { lbG = false; laufband(); }); }).observe(m, { childList: true, subtree: true }); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los, { once: true }); else los();
  })();
});

/* --- ode-handy-korrektur:L78:js --- */
__odeT('ode-handy-korrektur:L78:js', function () {
(function () {
    /* Suchhilfe: ?ode_test=kopf|blasen|stoerer|rest|trans|anim|footer|sA-B */
    var m = /[?&]ode_test=(kopf|blasen|stoerer|rest|trans|anim|footer|s(\d+)-(\d+))/.exec(location.search);
    if (m) {
      var aus = '{animation:none!important;transition:none!important}';
      var alle = 'main *,main *::before,main *::after,footer *,footer *::before,footer *::after';
      var css;
      if (m[2]) {
        var sel = 'main .shopify-section:nth-child(n+' + m[2] + '):nth-child(-n+' + m[3] + ')';
        css = sel + ',' + sel + ' *,' + sel + ' *::before,' + sel + ' *::after' + aus;
      } else {
        css = {
          kopf: 'header-component,header-component *,.header-section,.header-section *' + aus,
          blasen: '.ode-bl0-h,.ode-bl0-h *{animation:none!important}',
          stoerer: '.ode-st0{display:none!important}',
          rest: alle + aus,
          trans: alle + '{transition:none!important}',
          anim: alle + '{animation:none!important}',
          footer: 'footer,footer *,footer *::before,footer *::after' + aus
        }[m[1]];
      }
      var s = document.createElement('style'); s.textContent = css; document.head.appendChild(s);
    }
    if (window.__odeOben || !('IntersectionObserver' in window)) return;
    if (!matchMedia('(max-width: 749px)').matches) return;
    window.__odeOben = true;
    var start = function () {
      var w = document.querySelector('.page-wrapper') || document.body;
      var mk = document.createElement('div');
      mk.className = 'ode-oben-marke'; mk.setAttribute('aria-hidden', 'true');
      w.insertBefore(mk, w.firstChild);
      new IntersectionObserver(function (e) {
        var oben = e[e.length - 1].isIntersecting;
        document.documentElement.classList.toggle('ode-oben', oben);
        if (oben) {
          var h = document.querySelector('header-component[data-sticky-state="idle"]');
          if (h) { h.dataset.stickyState = 'inactive'; h.dataset.scrollDirection = 'none'; }
        }
      }).observe(mk);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();
});
